<template>
 <div>
   <report-settings v-if="!isReportFormed"/>
   <report-table v-if="isReportFormed"/>
 </div>
</template>

<script>
  import ReportSettings from './Report-settings'
  import ReportTable from './Report-table'
  export default {
    components: { ReportSettings, ReportTable },
    computed: {
      isReportFormed() {
        return this.$store.getters.isReportFormed
      }
    }
  }
</script>
